// extracted by mini-css-extract-plugin
export var backdropBlur = "_la-0";
export var contentCard = "_la-5";
export var frame = "_la-2";
export var image = "_la-4";
export var imagePane = "_la-3";
export var modal = "_la-1";